module.exports = __webpack_public_path__ + "static/media/cuack.d04d5b81.gif";